var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Action, Actions, Selector, State, Store } from '@ngxs/store';
import { MarkAsDirty, OpenObjectSettingsPanel } from './objects.actions';
import { CloseForePanel } from '../../../image-editor/state/editor-state-actions';
import { ActiveObjectService } from '../../../image-editor/canvas/active-object/active-object.service';
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { HistoryNames } from '../../../image-editor/history/history-names.enum';
import { BaseToolState } from '../base-tool.state';
import { DrawerName } from '../../toolbar-controls/drawers/drawer-name.enum';
var ObjectsState = /** @class */ (function (_super) {
    __extends(ObjectsState, _super);
    function ObjectsState(store, history, activeObject, actions$) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.history = history;
        _this.activeObject = activeObject;
        _this.actions$ = actions$;
        _this.toolName = DrawerName.OBJECT_SETTINGS;
        return _this;
    }
    ObjectsState.dirty = function (state) {
        return state.dirty;
    };
    ObjectsState.activePanel = function (state) {
        return state.activePanel;
    };
    ObjectsState.prototype.openObjectSettingsPanel = function (ctx, action) {
        ctx.patchState({ activePanel: action.panel });
    };
    ObjectsState.prototype.markAsDirty = function (ctx) {
        ctx.patchState({ dirty: true });
    };
    ObjectsState.prototype.cancelChanges = function (ctx) {
        if (ctx.getState().activePanel) {
            ctx.patchState({ activePanel: null });
        }
        else {
            this.store.dispatch(new CloseForePanel());
            this.activeObject.deselect();
        }
        if (ctx.getState().dirty) {
            this.history.reload();
        }
        ctx.patchState({ dirty: false });
    };
    ObjectsState.prototype.applyChanges = function (ctx) {
        this.store.dispatch(new CloseForePanel());
        if (ctx.getState().dirty) {
            this.history.add(HistoryNames.OBJECT_STYLE);
        }
        ctx.patchState({ dirty: false, activePanel: null });
        this.activeObject.deselect();
    };
    __decorate([
        Action(OpenObjectSettingsPanel),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, OpenObjectSettingsPanel]),
        __metadata("design:returntype", void 0)
    ], ObjectsState.prototype, "openObjectSettingsPanel", null);
    __decorate([
        Action(MarkAsDirty),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjectsState.prototype, "markAsDirty", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjectsState, "dirty", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ObjectsState, "activePanel", null);
    ObjectsState = __decorate([
        State({
            name: DrawerName.OBJECT_SETTINGS,
            defaults: {
                dirty: false,
                activePanel: null,
            }
        }),
        __metadata("design:paramtypes", [Store,
            HistoryToolService,
            ActiveObjectService,
            Actions])
    ], ObjectsState);
    return ObjectsState;
}(BaseToolState));
export { ObjectsState };
